module.exports = __webpack_public_path__ + "img/message.52e5abf7.svg";